import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=3fbe0f8b&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=js"
export * from "./Step2.vue?vue&type=script&lang=js"
import style0 from "./Step2.vue?vue&type=style&index=0&id=3fbe0f8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbe0f8b",
  null
  
)

export default component.exports